import { ImmutableGridCol } from "./ImmutableGridCol";
import { GridValidRowModel } from "@mui/x-data-grid/models/gridRows";

export class MutableGridCol<
  Item extends GridValidRowModel
> extends ImmutableGridCol<Item> {
  editable: boolean = true;
}
